import { render, staticRenderFns } from "./PlanoSelect.vue?vue&type=template&id=654c6f43"
import script from "./PlanoSelect.vue?vue&type=script&lang=js"
export * from "./PlanoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports